/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useEffect, useState} from 'react';
import MapBase from "./MapBase";
import useMapProps from "./useMapProps";
import {MapPropsProvider} from "./MapPropsContext";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import {
  formatServiceCode,
  formatUid,
  getApiUrl,
  getReadableFreq,
  makeTableSorterFn,
  degressToPosition,
  positionToDegress,
} from "../../utils";
import WidgetContainer from "./widgets/WidgetContainer";
import {WELL_KNOWN_POSITION, USER_GBN} from "../../Constants";
import WidgetVisibleRadius from "./widgets/WidgetVisibleRadius";
import WidgetSearchByUid from "./widgets/WidgetSearchByUid";
import WidgetImpCheckServiceCode, {OPTIONS as SERVICE_CODE_OPTIONS} from "./widgets/WidgetImpCheckServiceCode";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetGeocoding from "./widgets/WidgetGeocoding";
import Seperator from "./widgets/Seperator";
import WidgetVworldCityTypeForCenter from "./widgets/WidgetVworldCityTypeForCenter";
import WidgetUidWithShortcut from "./widgets/WidgetUidWithShortcut";
import WidgetToolbar from "./widgets/WidgetToolbar";
import WidgetTable from "./widgets/WidgetTable";
import EllipsisText from "./widgets/EllipsisText";
import AlignRightText from "./widgets/AlignRightText";
import WidgetCustomerCode, {CUSTOMER_OPTIONS as CUSTOMER_CODE_OPTIONS} from "./widgets/WidgetCustomerCode";
import AlignCenterText from "./widgets/AlignCenterText";
import AlignCenterText2 from "./widgets/AlignCenterText2";
import {message, Tooltip} from "antd";
import useVworldCityType from "./useVworldCityType";

const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.남산공원,
  zoom: 16,
};



const style2 = {
  right: '120px'
};

const legendStyle2 = {
  backgroundColor: 'rgba(255, 255, 255, 0)',
  boxShadow: 'none'
};

const CUSTOMER_NO_DICT = {
  'SKT 3.5G': [542604],
  'KT 3.5G': [542610],
  'LGU+ 3.5G': [39818],
   'SKT 28G': [541309],
  'KT 28G': [89987],
  'LGU+ 28G': [259976],
};



const ICON_MAPPING = {
  // vendorName
  'SKT 3.5G': {
    // 옥내
    true: {
      // service_code

           '11': ['5g-sk-in', 'SKT 3.5G'],

    },
    // 옥외
    false: {
//      '05': ['2g-sk-out', '2G'],
//      '06': ['2g-sk-out', '2G'],
      '11': ['5g-sk-in', 'SKT 3.5G'],
    },
  },
  'KT 3.5G': {
    // 옥내
    true: {
      '21': ['5g-kt-in', 'KT 3.5G'],

    },
    // 옥외
    false: {
//      '05': ['2g-kt-out', '2G'],
//      '06': ['2g-kt-out', '2G'],

      '21': ['5g-kt-in', 'KT 3.5G'],
    },
  },
  'LGU+ 3.5G': {
    // 옥내
    true: {
//      '05': ['2g-lg-in', '2G'],
//      '06': ['2g-lg-in', '2G'],
        '31': ['5g-lg-in', 'LGU+ 3.5G'],

    },
    // 옥외
    false: {
//      '05': ['2g-lg-out', '2G'],
//      '06': ['2g-lg-out', '2G'],
        '31': ['5g-lg-in', 'LGU+ 3.5G'],

    },
  },
  'SKT 28G': {
    // 옥내
    true: {
      // service_code

           '12': ['5g-sk-out', 'SKT 28G'],

    },
    // 옥외
    false: {
//      '05': ['2g-sk-out', '2G'],
//      '06': ['2g-sk-out', '2G'],
      '12': ['5g-sk-out', 'SKT 28G'],
    },
  },
  'KT 28G': {
    // 옥내
    true: {
      '22': ['5g-kt-out', 'KT 28G'],

    },
    // 옥외
    false: {
//      '05': ['2g-kt-out', '2G'],
//      '06': ['2g-kt-out', '2G'],

      '22': ['5g-kt-out', 'KT 28G'],
    },
  },
  'LGU+ 28G': {
    // 옥내
    true: {
//      '05': ['2g-lg-out', '2G'],
//      '06': ['2g-lg-out', '2G'],
        '32': ['5g-lg-out', 'LGU+ 28G'],

    },
    // 옥외
    false: {
//      '05': ['2g-lg-out', '2G'],
//      '06': ['2g-lg-out', '2G'],
        '32': ['5g-lg-out', 'LGU+ 28G'],

    },
  },
};


message.config({
  top: 250,
  duration: 15,
  maxCount: 1,
});

const infoByZoom = () => {
  message.info({
    content: <span style={{fontSize:15}}> 해당 zoom에서는 검색이 불가합니다. 확대해 주시기 바랍니다.</span>,
  });
};

const MapImpCheckSearch = () => {
  // eslint-disable-next-line no-unused-vars
  const [service_code, setServiceCode] = useState();
  const mapProps = useMapProps({
    INITIAL_VISIBLE_RADIUS: 500,
    INITIAL_VIEW_STATE,
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: (feature) => {
        const {customer_no, service_name, service_code, rds_svc_form_cd} = feature;

        // Warning: Cannot update a component from inside the function body of a different component.
        // 라는 경고가 200개씩 콘솔창에 찍히기 때문에, 아래에 useEffect()를 사용해서 setServiceCode(service_code) 했습니다.
        // setServiceCode(service_code);

        const vendorName = Object.entries(CUSTOMER_NO_DICT)
          .filter(([vendorName, customerNoList]) =>
            customerNoList.includes(customer_no)
          )
          .map(([vendorName]) => vendorName)[0];

        try {

          const isIndoor = service_name.indexOf("옥내") > -1;
          return ICON_MAPPING[vendorName][isIndoor][String(service_code || rds_svc_form_cd)][0];
        } catch (e) {
          //console.error("not found iconCode for", vendorName, service_name.indexOf("옥내"), rds_svc_form_cd);
          return null;
        }
      },
      getIconWidth: (feature, zoom) => {
        let iconWidth = 30;
        if(zoom <= 12 ){
          iconWidth -= iconWidth * (15 - Math.max(7, zoom)) / 11;
          return Math.min(25.2, iconWidth);
        } else if( zoom <= 13) {
          iconWidth -= iconWidth * (15 - Math.max(7, zoom)) / 5;
          return Math.min(25.2, iconWidth);
        } else if (zoom <= 14){
          iconWidth -= iconWidth * (15 - Math.max(7, zoom)) / 3;
          return Math.min(25.2, iconWidth);
        } else if ( zoom === 15) {
          iconWidth -= iconWidth * (16 - Math.max(7, zoom)) / 4;
          return Math.min(30, iconWidth);
        } else if ( zoom >= 16 ){
          return 30;
        }
      }
    },
    INITIAL_WIDGET_STATE: {
      service_code_list: SERVICE_CODE_OPTIONS.map(({value}) => value),
      visible_radius: 500,
      cus_code_list: CUSTOMER_CODE_OPTIONS.map(({value}) => value),
    },
  });

  const {
    viewState,
    clickedPointIconObjects,
    widgetState,
    setPointsLayerFilterFunc,
    setVisibleRadius,
    setClickedPointIconObjects,
    setNullForMapViewType, setSearchByUidForMapViewType,
    setIsClusteringPoint,
    setFilteredPointsResponseList,
  } = mapProps;

  const {latitude, longitude, zoom} = viewState;
  const [vworldCityType, setVworldCityType] = useState();

  // getIconCode 안에서 setServiceCode(service_code) 하게 되면,
  // Warning: Cannot update a component from inside the function body of a different component.
  // 라는 경고가 200개씩 콘솔창에 찍히기 때문에, useEffect()를 사용해서 setServiceCode(service_code) 했습니다.
  useEffect(() => {
    setServiceCode(service_code);
  }, [service_code]);

  useEffect(() => {
    // console.log("zoom level : " + zoom);
    if( zoom < 13) {
      infoByZoom();
    } else if( zoom >= 13) {
      message.destroy();
    }
    // zoom이 15이하일 때는 클러스터링 보기, 초과부터 아이콘 보기
    if(zoom <= 15){
      setIsClusteringPoint(true);
    } else if(zoom > 15){
      setIsClusteringPoint(false);
    }
  }, [zoom]);

  useEffect(() => {
    const {service_code_list, visible_radius, cus_code_list} = widgetState;
    setPointsLayerFilterFunc(() => ({service_code, customer_no}) =>
      service_code_list.map(row => row.split(',')).flat().includes(service_code) &&
      cus_code_list.map(row => row.split(',')).flat().includes(customer_no.toString()));
    setVisibleRadius(visible_radius);

    // console.log('search_uid_type:', search_uid_type);

  }, [widgetState]);

  const { setPosition: setPositionForCityType } = useVworldCityType(cityType => {
    setVworldCityType(cityType);
  });

  useEffect(() => {
    setPositionForCityType({ latitude, longitude });
  }, [clickedPointIconObjects]);

  const onClickedPointInWidgetTable = useCallback((feature) => {
    const {latitude, longitude, lat, lon} = feature;
    const newLatitude = positionToDegress(latitude || lat);
    const newLongitude = positionToDegress(longitude || lon);
    const newFeature = {...feature, position: [newLongitude, newLatitude]};
    setClickedPointIconObjects([newFeature]);
  }, [setClickedPointIconObjects]);


  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetContainer
          onChange={tabTitle => {
            if ( tabTitle === '허가번호 검색' ) {
//              setSearchByUidForMapViewType();
//              setClickedPointIconObjects([]);
//              setVisibleRadius(0);

               const {visible_radius} = widgetState;
              setVisibleRadius(visible_radius);
              setClickedPointIconObjects([]);
              setFilteredPointsResponseList([]);
              setNullForMapViewType();
            }
            else {
              const {visible_radius} = widgetState;
              setVisibleRadius(visible_radius);
              setClickedPointIconObjects([]);
              setFilteredPointsResponseList([]);
              setNullForMapViewType();
            }
          }}
        >
          <div title={"주소 검색"}>
            <WidgetGeocoding style={{
              margin: '-10px 0px 10px 0px',
            }}/>
            {USER_GBN && (USER_GBN === '2' || USER_GBN === '3') &&
            <WidgetCustomerCode/>
            }
            <WidgetImpCheckServiceCode/>
            <Seperator/>
            <WidgetVisibleRadius/>
          </div>
          <div title={"허가번호 검색"}>
            <WidgetSearchByUid fetchUrl={getApiUrl({type: "type3"})}/>
          </div>
        </WidgetContainer>

        <WidgetTableClicked
          fetchUrl={getApiUrl({type: "type2"})}
          getTitle={objects => `${objects.length}개의 장치`}
          //serviceInfo={true}
          objects={clickedPointIconObjects}
          //getRowTitle={({uid, rds_svc_form_cd}) => `${formatUid(uid)} (${formatServiceCode(rds_svc_form_cd)})`}
          getRow={({uid, cls_name, address, form_name, usage, customer_name, longitude, latitude}) =>
            <table>
              <tbody>
              <tr>
                <th>허가번호</th>
                <td>{formatUid(uid)}</td>
              </tr>
              <tr>
                <th>호출명칭</th>
                <td>{cls_name}</td>
              </tr>
               <tr>
                <th>시설자명</th>
                <td>{customer_name}</td>
              </tr>

              <tr>
                <th>설(상)치장소</th>
                <td>{address}</td>
              </tr>
              <tr>
                <th>할당대역</th>
                <td>{form_name}</td>
              </tr>
              <tr>
                <th>용도지역정보</th>
                <td>{vworldCityType}</td>
              </tr>
              <tr>
                <th>경도</th>
                <td>{`${degressToPosition(longitude)}(${longitude})`}</td>
              </tr>
              <tr>
                <th>위도</th>
                <td>{`${degressToPosition(latitude)}(${latitude})`}</td>
              </tr>
              </tbody>
            </table>
          }
        />

        <WidgetTable
          fetchUrl={getApiUrl({type: "type1"})}
          getTitle={objects => `${objects.length}개의 무선국`}
          isUidSearch={true}
          columns={[
            {title: '순번', dataIndex: 'index', key: 'index', width: 75, align: 'center', sorter: makeTableSorterFn('index'), fixed: 'left'},
            {
              title: '허가번호', dataIndex: 'uid', key: 'uid', width: 200,
              render: (uid, feature) => WidgetUidWithShortcut({feature, onClick: onClickedPointInWidgetTable}),
              sorter: makeTableSorterFn('uid'), fixed: 'left'
            },
            {
              title: '설(상)치장소', dataIndex: 'rds_trs_adr', key: 'rds_trs_adr', width: 500,
              render: rds_trs_adr => <EllipsisText text={rds_trs_adr}/>,
              sorter: makeTableSorterFn('rds_trs_adr')
            },
            {
              title: '용도', dataIndex: 'service_name', key: 'service_name', width: 400,
              sorter: makeTableSorterFn('service_name')
            },
            {
              title: '장치개수', dataIndex: 'rds_eqm_snu', key: 'rds_eqm_snu', width: 100,
              render: text => AlignCenterText({text}),
              sorter: makeTableSorterFn('rds_eqm_snu')
            },
            // {
            //   title: '인증번호', dataIndex: 'toap_no', key: 'TOAP_NO', width: 240
            //   ,render: toap_no => <EllipsisText text={toap_no} />
            //   ,sorter: makeTableSorterFn('toap_no')
            // },
            {
              title: '경도', dataIndex: 'lon', key: 'lon', width: 140,
              render: text => AlignCenterText({text})
            },
            {
              title: '위도', dataIndex: 'lat', key: 'lat', width: 140,
              render: text => AlignCenterText({text})
            },

            {
              //title: '주파수 대역(MHz)', dataIndex: 'frq_hz', key: ['frq_hz','service_code'], width: 130,
              title: '주파수 대역(MHz)', dataIndex: 'frq_hz_100', key: 'frq_hz_100', width: 130,
              /* render: text => AlignCenterText2({text}), */
              render: text => AlignCenterText({text}),


              sorter: makeTableSorterFn('frq_hz')
            },
            {
              title: '출력(W)', dataIndex: 'arw_pwr_wtt', key: 'arw_pwr_wtt', width: 100,
              render: text => AlignRightText({text}),
              sorter: makeTableSorterFn('arw_pwr_wtt')
            },
            {
              title: '안테나설치형태', dataIndex: 'arw_wek_nsn_form_cd_nm', key: 'arw_wek_nsn_form_cd_nm', width: 160,
              sorter: makeTableSorterFn('arw_wek_nsn_form_cd_nm')
            },
            {
              title: '기지국ID', dataIndex: 'arw_gan_nmv', key: 'arw_gan_nmv', width: 100,
              render: text => AlignRightText({text}),
              sorter: makeTableSorterFn('arw_gan_nmv')
            },
            {
              title: '전파수신레벨', dataIndex: 'arw_alt_altd_het', key: 'arw_alt_altd_het', width: 100,
              render: text => AlignRightText({text}),
              sorter: makeTableSorterFn('arw_alt_altd_het')
            },

          ]}
          horizontalScroll={2200}
        />

        <WidgetVworldCityTypeForCenter/>

      </MapBase>
      <WidgetToolbar/>
    </MapPropsProvider>
  );
};


export default MapImpCheckSearch;